import GeneralMapper from './General_Mapper'

const userMapper = async (data, totalRows) => {
    let responseData = [];
    for (var i = 0; i < data.length; i++) {
        responseData[i] = {
            id: data[i].secuencialUsuario ?? data[i].secuenciaPersonal ?? '',
            Usuarios: data[i].nombreUsuario ?? '',
            Rol: data[i].listRoles ?? [],
            Estado: data[i].esActivo = 'S' ? 'Activo' : 'Inactivo',
            Correo: data[i].correo ?? ''
        }
        responseData.push();
    }
    return GeneralMapper.successMapper(responseData, totalRows)
}

const userByIdMapper = async (data) => {

    const responseData = {
        id: data.secuenciaUsuario ?? '',
        codigoEmpresa: data.codigoEmpresa ?? '',
        secuenciaPersonal: data.secuenciaPersonal ?? '',
        esUsuarioNomina: data.esUsuarioNomina ?? '',
        primerNombre: data.primerNombre ?? '',
        segundoNombre: data.segundoNombre ?? '',
        primerApellido: data.primerApellido ?? '',
        segundoApellido: data.segundoApellido ?? '',
        nombreCompleto: data.nombreCompleto ?? '',
        codigoTipoIdentificacion: data.codigoTipoIdentificacion ?? '',
        numeroIdentificacion: data.numeroIdentificacion ?? '',
        fechaNacimiento: data.fechaNacimiento ?? '',
        sexo: data.sexo ?? '',
        edad: data.edad ?? '',
        correoElectronico: data.correoElectronico ?? '',
        estado: data.estado ?? '',
        codigoUsuario: data.codigoUsuario ?? '',
        esActivo: data.esActivo ?? '',
        estadoUsuario: data.estadoUsuario ?? '',
        esPersonalSanitario: data.esPersonalSanitario ?? '',
        codigoPaisNacionalidad: data.codigoPaisNacionalidad ?? '',
        nombreNacionalidad: data.nombreNacionalidad ?? ''
    }
    return GeneralMapper.successMapper(responseData, 0)
}

// Enlista los reoles de la api cuando deveelve todo los usuarios
const rolesMapper = async (dataRep) => {
    let responseData = [];
    const data = dataRep.listRol
    for (var i = 0; i < data.length; i++) {
        responseData[i] = {
            id: data[i].secuenciaRolXEmpresa ?? '',
            Codigo: data[i].codigoRol ?? '',
            Nombre: data[i].nombreRol ?? '',
            Descripcion: data[i].descripcionRol ?? '',
            listOpciones: data[i].listOpciones ?? '',
            Fecha: data[i].fechaCreacion ?? ''
        }
        responseData.push();
    }
    return GeneralMapper.successMapper(responseData, dataRep.totalRows)
}


// Enlista los reoles de la api cuando deveelve todo los usuarios
const rolesMapperXUsuario = async (dataRep) => {
    let responseData = [];

    console.log("----------->>>>", dataRep);
    const data = dataRep.listRolDash
    for (var i = 0; i < data.length; i++) {
        responseData[i] = {
            Codigo: data[i].codigoRol ?? '',
            Nombre: data[i].nombreRol ?? '',
            Descripcion: data[i].descripcionRol ?? '',
        }
        responseData.push();
    }
    return GeneralMapper.successMapper(responseData, dataRep.totalRows)
}


const rolesBIMapper = async (data) => {
    let responseData = [];
    for (var i = 0; i < data.rows.length; i++) {
        responseData[i] = {
            id: data.rows[i].secuenciaRolXEmpresa ?? '',
            Codigo: data.rows[i].codigoRol ?? '',
            Nombre: data.rows[i].nombreRol ?? '',
            Descripcion: data.rows[i].descripcionRol ?? '',
            listOpciones: data.rows[i].listOpciones ?? '',
            Fecha: data.rows[i].Fecha ?? ''
        }
        responseData.push();
    }
    return GeneralMapper.successMapper(responseData, data.totalRows)
}

const AuthMapper = {
    userMapper,
    rolesMapper,
    userByIdMapper,
    rolesBIMapper,
    rolesMapperXUsuario
}

export default AuthMapper
